export const typesNodes = {
  title: "titleIntentNode",
  entry: "entryIntentNode",
  contextInput: "contextInputIntentNode",
  phrasesInput: "phrasesInput",
  event: "eventIntentNode",
  response: "responseIntentNode",
  contextOutput: "contextOutputIntentNode",
  conditionalResponses: "conditionalResponsesIntentNode",
  responsePhrases: "responsePhrasesIntentNode",
  parameter: "parameterIntentNode",
  parameterConfig: "ParameterConfigIntentNode",
  extension: "extensionIntentNode",
  extensionConfig: "extensionConfigIntentNode",
  extensionsVariablesFlow: "extensionsVariablesFlow",
  integration: "integrationIntentNode",
  integrationConfig: "integrationConfigIntentNode",
  description: "descriptionIntentNode",
  defaultResponse: "defaultResponseIntentNode",
  buttonAdd: "buttonAdd",
  addButton: "addButton",
  buttonAddParams: "buttonAddParams",
  buttonAddExtensions: "ButtonAddExtensions",
  buttonAddExtension: "ButtonAddExtension",
  
};
